import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';

import { canUserApproveBooking, isManipulated } from '../../../services/booking/recourse-booking-functions';
import { BookingRoutingService } from '../../../services/details-view-service/booking-routing.service';
import { User } from '../../../services/user-service/model/user.model';
import { UserService } from '../../../services/user-service/user.service';
import { ApproveRejectReprocessDialog } from '../../../shared/approve-reject-reprocess-dialog/approve-reject-reprocess-dialog.component';

@Component({
  selector: 'app-approval-button-cell-renderer',
  templateUrl: './approval-button-cell-renderer.html',
  imports: [PasButtonRoundComponent, TranslatePipe, ApproveRejectReprocessDialog],
})
export class ApprovalButtonCellRenderer implements OnInit, ICellRendererAngularComp {
  private readonly userService = inject(UserService);
  private readonly bookingRoutingService = inject(BookingRoutingService);

  private data: any;
  private user: User;
  private manipulated: boolean;
  private invalidAttachments: boolean;
  private gridApi: GridApi;
  private params: any;

  public readonly pasButtonRoundColor = PasButtonRoundColor;

  @ViewChild(ApproveRejectReprocessDialog)
  public approveRejectReprocessDialog: ApproveRejectReprocessDialog;

  public refresh(): boolean {
    return true;
  }

  public ngOnInit(): void {
    this.user = this.userService.getUser();
  }

  public agInit(params: any): void {
    this.params = params;
    this.gridApi = params.api;
    this.invalidAttachments = !params.data.signatureValidAttachments;
    this.manipulated = isManipulated(params.data) || this.invalidAttachments;
    this.data = params.data;
  }

  public onDetailClicked(): void {
    this.bookingRoutingService.openBookingDetailsView(this.data.pkBookingId);
  }

  public async onApproveClicked(): Promise<void> {
    const result = await this.approveRejectReprocessDialog.onBtnApproveBooking(this.data.pkBookingId);
    if (result) {
      this.gridApi.applyTransaction({ remove: [this.data] });
      this.params.context.componentParent.recalculateAutomaticBookings();
    }
  }

  public async onRejectClicked(): Promise<void> {
    const result = await this.approveRejectReprocessDialog.onBtnRejectBooking(this.data.pkBookingId);
    if (result) {
      this.gridApi.applyTransaction({ remove: [this.data] });
      this.params.context.componentParent.recalculateAutomaticBookings();
    }
  }

  public isValid(): boolean {
    return !this.manipulated;
  }

  public canUserApprove(): boolean {
    return canUserApproveBooking(this.user, this.data);
  }
}
